import { addMinutes } from "date-fns";
const expiryDurationInMinutes = Number(process.env.REACT_APP_REMINDER_COOKIE_TIMEOUT_IN_MINUTES || 1);

const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return null;
};

export const createCookie = <T>(name: string, value: T, expiryInMinutes: number) => {
  let date = new Date()
  date = addMinutes(date, expiryInMinutes)

  document.cookie = `${name}=${`${value}|${date}`}; expires=${date.toUTCString()}; path=/`;
}

export const checkForrTTreatmentCookie = (): boolean => {
  const rtVisited = getCookie('rtvisited');
  if (!rtVisited) {
    createCookie('rtvisited', true, expiryDurationInMinutes)
    return false;
  } else {
    return true;
  }
}

export const changeForNewExpiry = () => {
  createCookie('rtvisited', true, expiryDurationInMinutes)
}

export const checkIfCookieIsExpired = (name: string): boolean | null => {
  const cookie = getCookie('rtvisited');

  if (!cookie) return null;
  const [, expiry] = cookie.split('|');

  return Date.now() > new Date(expiry).getDate();
}
